import Result from "@/core/common/Result";

export interface IObterMensagemBoasVindasUseCase {
  execute(): Promise<Result<boolean>>;
}

export const obterMensagemBoasVindasUseCaseDI =
  "ObterMensagemBoasVindasUseCaseDI";
